import { Controller, useForm } from "react-hook-form";
import { CounterInputControls, Input } from "ui";

import { FeedInsertSettings } from "../../../content.types";
import { FeedInsertsSettingsFormProps } from "./FeedInsertsSettingsForm.types";

const FeedInsertsSettingsForm = ({
  formId,
  defaultValues,
  onSubmit
}: FeedInsertsSettingsFormProps) => {
  const { control, handleSubmit } = useForm<FeedInsertSettings>({
    defaultValues
  });

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="showInsertsAfterSpecifiedNumberOfProducts"
        render={({ field: { value, onChange } }) => (
          <Input
            label="Show new insert after every number of products:"
            value={value}
            onChange={onChange}
            type="number"
            min={2}
            max={100}
            action={
              <CounterInputControls
                value={value}
                onChange={onChange}
                min={2}
                max={100}
              />
            }
            step={1}
          />
        )}
      />
    </form>
  );
};

export default FeedInsertsSettingsForm;
